import { use_slice_collections, use_slice_grid2d } from '@/hooks/store/use_slices';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { useMemo } from 'react';
import { WATCHER_GRID2D__get_collection } from '../../watchers/grid2d/WATCHER_GRID2D__get_collection';
import { GRID2D__float } from '../views/GRID2D__float';
import { GRID2D__loading } from '../views/GRID2D__loading';

interface Props {
  entity_type: string;
  entity_id: string;
}

export function GRID2D__collection({ entity_type, entity_id }: Props) {
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);
  const { collections_map, collection_current } = use_slice_collections(['collections_map', 'collection_current']);

  const grid2d = useMemo(() => get_grid2d(), [entity_id, grids2d_map]);
  const entity = useMemo(() => get_entity(), [entity_id, collections_map]);

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */
  function get_grid2d() {
    //wait for load grid from server
    if (!grids2d_map.has(entity_id)) return DTO__grid2d.CREATE_STUB();

    let out = grids2d_map.get_or_assert(entity_id);

    return out.clone();
  }

  function get_entity() {
    if (!collections_map.has(entity_id)) return DTO__entity_with_grid2d.CREATE_STUB();

    let out = collections_map.get_or_assert(entity_id, { context: 'collection' });

    return out.clone();
  }

  /*
   * RENDERS
   */

  function render_grid() {
    if (grid2d.is_stub()) return <GRID2D__loading {...{ entity }} />;
    if (entity.is_stub()) return <GRID2D__loading {...{ entity }} />;

    return <GRID2D__float {...{ entity, grid2d }} use_offset_from_slug={entity._id === collection_current._id} />;
  }

  /*
   * HTML
   */

  return (
    <>
      <WATCHER_GRID2D__get_collection {...{ entity_id, entity_type }} />
      <div className="size-full p-[1px] bg-component">{render_grid()}</div>
    </>
  );
}
